import { render, staticRenderFns } from "./SelectChapter.vue?vue&type=template&id=2a5838cc"
import script from "./SelectChapter.vue?vue&type=script&lang=js"
export * from "./SelectChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports